export const WIDGET_OPENING_TIME = 300
